import {Link} from "react-router-dom"
const links = [
    {to:"/",title:"Home"},
    {to:"/dashboard",title:"Dashboard"},
    {to:"/setting",title:"Setting"}
]
function Navbar(){
    return(links.map((link)=><Link to={link.to}>{link.title}</Link>)
 )
}

export default Navbar